import React from "react";
import loaderStyles from "./loaderStyles.css";

const LoadingSpinner = () => {
  return(
    <div className="lds-roller" style={loaderStyles}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  )
}

export default LoadingSpinner;